const initalState = {data: "", surroundingCityZone: ""}

export const UPDATE_ONSTREET_COMMON_MARKER_DATA = 'UPDATE_ONSTREET_COMMON_MARKER_DATA'

export function onstreetCommonMarkerDataReducer (state = initalState, action) {
    switch (action.type){
        case UPDATE_ONSTREET_COMMON_MARKER_DATA:
            return action.payload
        default: return state
    }
}